import { DefaultBadge } from "../atoms/StatusBadge";
import { useOrganizationVariable } from "../hooks/useOrganizationVariables";
import { OrganizationSecret, OrganizationVariable } from "../models/types";
import { RectangularLoader } from "../molecules/skeleton-loader/RectangularLoader";
import { TableTextWithEllipsis } from "../molecules/TableTextWithEllipsis";

type RenderOrganizationVariableSecretProps = {
  type: "Variable" | "Secret";
  value: OrganizationVariable | OrganizationSecret | null;
};

export const RenderOrganizationVariableSecret = ({
  type,
  value,
}: RenderOrganizationVariableSecretProps) => {
  // if type is secret or value is null, don't fetch data from api
  const { data, isLoading } = useOrganizationVariable(type === "Secret" ? "" : value?.id ?? "", {});

  if (type === "Secret") {
    return <DefaultBadge value={value?.name ?? ""} />;
  }

  return isLoading ? (
    <RectangularLoader width="100px" height="14px" />
  ) : (
    <TableTextWithEllipsis value={`${data?.value}`} />
  );
};
